export default __webpack_public_path__ + "static/media/VIPL_Fiscal_23.194fb4e4.pdf";